import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { TranslatorModule } from '../../../translator/index';

import { ButtonComponent } from './button.component';

@NgModule({
    declarations: [
        ButtonComponent
    ],
    imports: [
        CommonModule,
        TranslatorModule
    ],
    exports: [
        ButtonComponent
    ]
})

/**
 * Module for Button component
 */
export class ButtonModule { }